import { Component, computed, input, InputSignal, Signal } from '@angular/core';
import { $dt } from '@primeuix/themes';

@Component({
  selector: 'app-convivia-logo',
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      [attr.viewBox]="'0 0 136 136'"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M74.6111 0C77.2191 4.86771e-07 79.3333 2.11421 79.3333 4.72222C79.3333 7.33023 77.2191 9.44444 74.6111 9.44444H26.4444C17.0556 9.44444 9.44444 17.0556 9.44444 26.4444V109.556C9.44444 118.944 17.0556 126.556 26.4444 126.556H109.556C118.944 126.556 126.556 118.944 126.556 109.556V59.5C126.556 56.892 128.67 54.7778 131.278 54.7778C133.886 54.7778 136 56.892 136 59.5V109.556L135.991 110.238C135.634 124.301 124.301 135.634 110.238 135.991L109.556 136H26.4444L25.7619 135.991C11.6993 135.634 0.365492 124.301 0.00922309 110.238L0 109.556V26.4444C0 12.0678 11.4725 0.371238 25.7619 0.00922309L26.4444 0H74.6111Z"
        [attr.fill]="fill()" />
      <path
        d="M59.0093 22.7331C60.4703 21.8896 62.2705 21.8896 63.7315 22.7331L89.25 37.466C90.711 38.3096 91.6111 39.8685 91.6111 41.5555V107.667C91.611 110.275 89.4968 112.389 86.8889 112.389C84.281 112.389 82.1668 110.275 82.1667 107.667V44.2801L66.0927 35.0016V55.7222H72.7222C75.3302 55.7222 77.4444 57.8364 77.4444 60.4444C77.4443 63.0524 75.3302 65.1667 72.7222 65.1667H66.0927V72.7222H72.7222C75.3302 72.7222 77.4444 74.8364 77.4444 77.4444C77.4443 80.0524 75.3302 82.1667 72.7222 82.1667H66.0927V88.7778H72.7222C75.3302 88.7778 77.4444 90.892 77.4444 93.5C77.4443 96.1079 75.3302 98.2222 72.7222 98.2222H66.0927V107.667C66.0925 110.275 63.9784 112.389 61.3704 112.389C58.7626 112.389 56.6483 110.274 56.6482 107.667V47.8457L41.5555 56.5578V107.667C41.5554 110.275 39.4413 112.389 36.8333 112.389C34.2254 112.389 32.1112 110.275 32.1111 107.667V53.8333C32.1111 52.1463 33.0112 50.5874 34.4722 49.7438L56.6482 36.9403V26.8226L56.6593 26.5072C56.7637 24.9431 57.64 23.5238 59.0093 22.7331Z"
        [attr.fill]="fill()" />
    </svg>
  `,
})
export class ConviviaLogoComponent {
  public size: InputSignal<string> = input('136px');
  public color: InputSignal<string | undefined> = input<string>();

  public fill: Signal<string> = computed<string>(() => {
    const customColor = this.color();
    if (customColor) return customColor;
    return $dt('green.500').value as string;
  });
}
